module.exports = __webpack_public_path__ + "static/img/news5_img.2833d92.png";